import { render, staticRenderFns } from "./WindingTemperatureChart.vue?vue&type=template&id=804240c4&scoped=true&"
import script from "./WindingTemperatureChart.vue?vue&type=script&lang=js&"
export * from "./WindingTemperatureChart.vue?vue&type=script&lang=js&"
import style0 from "./WindingTemperatureChart.vue?vue&type=style&index=0&id=804240c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804240c4",
  null
  
)

export default component.exports